webpackJsonp([35783957827783],{

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(47);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(65);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(251);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _bloomer = __webpack_require__(25);
	
	var _hero = __webpack_require__(49);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _indexModule = __webpack_require__(568);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'libermatic. - Open sourcing humans'
	      ),
	      _react2.default.createElement('meta', {
	        name: 'description',
	        content: 'libermatic builds and provides tools for startups and contemporary businesses alike to help solve problems.'
	      })
	    ),
	    _react2.default.createElement(
	      _hero2.default,
	      data.heroImage,
	      _react2.default.createElement(
	        _bloomer.Title,
	        { isSpaced: true, className: _indexModule2.default.title },
	        'Ever wished managing your business was easy and fun?'
	      ),
	      _react2.default.createElement(
	        _bloomer.Subtitle,
	        null,
	        'With ERPNext, you just might.'
	      ),
	      _react2.default.createElement(
	        _bloomer.Button,
	        {
	          to: '/services/erpnext',
	          render: function render(props) {
	            return _react2.default.createElement(_gatsbyLink2.default, props);
	          },
	          'aria-label': 'More Info'
	        },
	        'More About ERPNext'
	      )
	    ),
	    _react2.default.createElement(
	      _bloomer.Container,
	      { className: _indexModule2.default.section },
	      _react2.default.createElement(
	        _bloomer.Columns,
	        null,
	        _react2.default.createElement(
	          _bloomer.Column,
	          { isSize: '1/4' },
	          _react2.default.createElement(
	            _bloomer.Content,
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Technology and You'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _bloomer.Column,
	          { className: _indexModule2.default.content },
	          _react2.default.createElement(
	            _bloomer.Content,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Adopting any new technology always seems daunting. Particularly so, if it is going to affect a critical portion of your life. But it doesn\'t always have to like that.'
	            ),
	            _react2.default.createElement(
	              'blockquote',
	              null,
	              'Any sufficiently advanced technology is indistinguishable from magic. \u2014 Arthur C Clarke'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We believe that we can aid you in a few aspects of adopting and implementing these major decisions. We offer our services to possibly help you ease into this transition. We provide you information and services to handle these.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Meanwhile you can continue doing what you do best \u2014 run your business.'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { 'aria-hidden': true, className: _indexModule2.default.divider },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: data.sectionOneImage.sizes })
	    ),
	    _react2.default.createElement(
	      _bloomer.Container,
	      { className: _indexModule2.default.section },
	      _react2.default.createElement(
	        _bloomer.Columns,
	        null,
	        _react2.default.createElement(
	          _bloomer.Column,
	          { isSize: '1/4' },
	          _react2.default.createElement(
	            _bloomer.Content,
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Who are we?'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _bloomer.Column,
	          { className: _indexModule2.default.content },
	          _react2.default.createElement(
	            _bloomer.Content,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'em',
	                { className: _indexModule2.default.smallCaps },
	                'libermatic.'
	              ),
	              ' is a consulting firm based out of Imphal, IN that strives to solve problems solely using open source tools in a sustainable way.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We use modern tools and industry best practises to deliver high quality products. Furthermore, as a result of using extremely lean teams and our unique approach, the products we build tend to be considerable cheaper than other alternatives.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Thinking of giving us a try?'
	            )
	          ),
	          _react2.default.createElement(
	            _bloomer.Button,
	            {
	              isColor: 'primary',
	              to: '/contact',
	              render: function render(props) {
	                return _react2.default.createElement(_gatsbyLink2.default, props);
	              },
	              'aria-label': 'Contact'
	            },
	            'Reach Us'
	          )
	        )
	      )
	    )
	  );
	};
	IndexPage.propTypes = {
	  data: _propTypes2.default.shape({
	    heroImage: _propTypes2.default.object
	  }).isRequired
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"section":"src-pages----index-module---section---l4Kpe","content":"src-pages----index-module---content---1f4nN","smallCaps":"src-pages----index-module---smallCaps---vc3eP","pointers":"src-pages----index-module---pointers---aQ5ns","icon":"src-pages----index-module---icon---1AvPU","title":"src-pages----index-module---title---1LAhw","divider":"src-pages----index-module---divider---qg2V3"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-05ca1b05be828d4e5bf7.js